import React, { memo } from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';
import { Icon } from '@picsio/ui';
import { Info } from '@picsio/icons';

import localization from '../../../../shared/strings';
import Tooltip from '../../../Tooltip/Tooltip';
import styles from './AggregatedMultipleValueHint.module.scss';

const aggregatedL10n = localization.PRODUCT_INFO.aggregated;

const AggregatedMultipleValueHint = ({ className }) => (
  <Tooltip content={aggregatedL10n.multipleValues} placement="top">
    <span className={cn(styles.hint, className)}>
      <Icon size="sm">
        <Info />
      </Icon>
    </span>
  </Tooltip>
);

AggregatedMultipleValueHint.propTypes = {
  className: PropTypes.string,
};

AggregatedMultipleValueHint.defaultProps = {
  className: null,
};

export default memo(AggregatedMultipleValueHint);
